import ProductTile from 'components/Catalog/ProductGrid/ProductTile/ProductTile';
import { withProductTileProps } from 'viewModel/catalog/productGrid/productTile/withProductTileProps';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ProductTileEN from 'components/Catalog/ProductGrid/ProductTile/locales/ProductTile_en_US.js';
import ProductTileFR from 'components/Catalog/ProductGrid/ProductTile/locales/ProductTile_fr_CA.js';
import CatalogEN from 'components/Catalog/locales/Catalog_en_US.js';
import CatalogFR from 'components/Catalog/locales/Catalog_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(ProductTileEN, ProductTileFR);
const getCatalogText = getLocalisedDataFromResource(CatalogEN, CatalogFR);

const localization = createStructuredSelector({
    newText: getTextFromResource(getText, 'new'),
    valueText: getTextFromResource(getText, 'value'),
    colorsText: getTextFromResource(getText, 'colors'),
    colorText: getTextFromResource(getText, 'color'),
    sizesText: getTextFromResource(getText, 'sizes'),
    quickLookText: getTextFromResource(getText, 'quickLook'),
    sponsoredText: getTextFromResource(getText, 'sponsored'),
    regPriceText: getTextFromResource(getText, 'regPrice'),
    selectSalesItemsText: getTextFromResource(getText, 'selectSaleItems'),
    viewSimilarProductsText: getTextFromResource(getText, 'viewSimilarProducts'),
    purchasedText: getTextFromResource(getText, 'purchased'),
    bestsellerText: getTextFromResource(getText, 'bestseller'),
    buyItAgainText: getTextFromResource(getText, 'buyItAgain'),
    percentageOffText: getTextFromResource(getText, 'percentageOff', ['{0}']),
    percentageOffRangeText: getTextFromResource(getText, 'percentageOffRange', ['{0}']),
    compareText: getTextFromResource(getCatalogText, 'compare'),
    timeText: getTextFromResource(getText, 'time'),
    timesText: getTextFromResource(getText, 'times')
});

const fields = createSelector(localization, locales => {
    return {
        locales
    };
});

const withProductTileComponentProps = wrapHOC(connect(fields, null));

export default withProductTileComponentProps(withProductTileProps(ProductTile));
